const hardcodedTranslations: Record<string, Record<string, string>> = {
  generic: {
    'error_undetermined_line-1': 'We are experiencing difficulties displaying the widget.',
    'error_undetermined_line-2': 'Sorry for the inconvenience.'
  },
  'ru-RU': {
    'error_undetermined_line-1': 'Мы испытываем трудности с отображением виджета.',
    'error_undetermined_line-2': 'извините за причиненные неудобства'
  }
};

const matchTypeAcronyms: { [key in MatchType]: string } = {
  best_of: 'BO',
  first_to: 'FT',
  all_games_played: 'AGP',
  red_bull_home_ground: 'RBHG',
  ow_best_of: '',
  custom: ''
};

const currencies: Record<string, string> = {
  'Chinese Yuan': 'CN¥',
  Euro: '€',
  'Russian Ruble': '₽.',
  'South Korean Won': '₩',
  'United States Dollar': '$'
};

export { hardcodedTranslations, matchTypeAcronyms, currencies };
